// inspired by https://usehooks.com/useLocalStorage/

import { useState } from 'react'

/**
 * Saves and retrieves values from LocalStorage
 * @param key The key which adresses the entity
 * @param initialValue The initial value of the entity
 */
export const useLocalStorage = (key: string, initialValue: string): [string, (arg: string) => void] => {
  const [storedValue, setStoredValue] = useState<string>(() => {
    try {
      const item = window.localStorage.getItem(key)
      return item ? (JSON.parse(item) as string) : initialValue
    } catch (error) {
      console.log(error)
      return initialValue
    }
  })

  const setValue = (value: string): void => {
    try {
      const valueToStore: string = value
      setStoredValue(valueToStore)
      window.localStorage.setItem(key, JSON.stringify(valueToStore))
    } catch (error) {
      console.log(error)
    }
  }

  return [storedValue, setValue]
}
